import { IListPageResponse } from "types/globalTypes";
import { IAcademyPlayer, PLAYER_STATE, TRANSFER_LEVEL } from "types/transfer/player.interface";
import { createMockListPage } from "./listingMocks";
import { demoPlayerPhoto } from "./demoImages";
import { demoApi } from "./demoLocale";
import {
  DEMO_ACADEMY_ID,
  DEMO_ACADEMY_NORTH_ID,
  DEMO_ACADEMY_SOUTH_ID,
  DEMO_GROUP_U13B,
  DEMO_GROUP_U14W,
  DEMO_GROUP_U15A,
  DEMO_GROUP_U17,
  matchesAcademyIds,
  matchesGroupIds,
  matchesHasAppliedPass,
  matchesOptionalNumber,
} from "./mockFilterHelpers";

export { DEMO_ACADEMY_ID } from "./mockFilterHelpers";

type MockAcademyPlayer = IAcademyPlayer & {
  GroupId?: string;
  PhotoFilePath?: string;
};

export const mockPlayers: MockAcademyPlayer[] = [
  {
    PlayerId: "00000000-0000-0000-0000-000000000101",
    Name: "Jan Kowalski",
    PhotoFilePath: demoPlayerPhoto("00000000-0000-0000-0000-000000000101"),
    Birthday: new Date("2010-05-15"),
    Level: TRANSFER_LEVEL["Członkowska"],
    State: PLAYER_STATE["Aktywny"],
    CurrentState: PLAYER_STATE["Aktywny"] as unknown as IAcademyPlayer["CurrentState"],
    GroupName: "Pierwsza drużyna",
    GroupId: DEMO_GROUP_U15A,
    Status: "0",
    Academy: { AcademyId: DEMO_ACADEMY_ID, Name: "Klub piłkarski" },
    TotalUnpaidTransactionsAmount: 0,
    HasAppliedPass: true,
    RelatedUsersEmails: "rodzic.kowalski@demo.pl",
    PhoneNumber: "500100200",
  },
  {
    PlayerId: "00000000-0000-0000-0000-000000000102",
    Name: "Adam Nowak",
    PhotoFilePath: demoPlayerPhoto("00000000-0000-0000-0000-000000000102"),
    Birthday: new Date("2012-03-22"),
    Level: TRANSFER_LEVEL["Obserwacja"],
    State: PLAYER_STATE["Zawodnik obserwowany"],
    CurrentState: PLAYER_STATE["Zawodnik obserwowany"] as unknown as IAcademyPlayer["CurrentState"],
    GroupName: "Rezerwy",
    GroupId: DEMO_GROUP_U13B,
    Status: "0",
    Academy: { AcademyId: DEMO_ACADEMY_ID, Name: "Klub piłkarski" },
    TotalUnpaidTransactionsAmount: 150.5,
    HasAppliedPass: false,
    RelatedUsersEmails: "a.nowak@demo.pl",
    PhoneNumber: "600200300",
  },
  {
    PlayerId: "00000000-0000-0000-0000-000000000103",
    Name: "Piotr Wiśniewski",
    PhotoFilePath: demoPlayerPhoto("00000000-0000-0000-0000-000000000103"),
    Birthday: new Date("2008-11-08"),
    Level: TRANSFER_LEVEL["Członkowska"],
    State: PLAYER_STATE["Aktywny"],
    CurrentState: PLAYER_STATE["Aktywny"] as unknown as IAcademyPlayer["CurrentState"],
    GroupName: "U17",
    GroupId: DEMO_GROUP_U17,
    Status: "0",
    Academy: { AcademyId: DEMO_ACADEMY_ID, Name: "Klub piłkarski" },
    TotalUnpaidTransactionsAmount: 0,
    HasAppliedPass: true,
    RelatedUsersEmails: "wiśniewski@demo.pl",
    PhoneNumber: "510300400",
  },
  {
    PlayerId: "00000000-0000-0000-0000-000000000201",
    Name: "Kacper Malinowski",
    PhotoFilePath: demoPlayerPhoto("00000000-0000-0000-0000-000000000201"),
    Birthday: new Date("2011-04-12"),
    Level: TRANSFER_LEVEL["Członkowska"],
    State: PLAYER_STATE["Aktywny"],
    CurrentState: PLAYER_STATE["Aktywny"] as unknown as IAcademyPlayer["CurrentState"],
    GroupName: "Trampkarz 2014",
    GroupId: DEMO_GROUP_U14W,
    Status: "0",
    Academy: { AcademyId: DEMO_ACADEMY_NORTH_ID, Name: "Oddział Akademii" },
    TotalUnpaidTransactionsAmount: 0,
    HasAppliedPass: true,
    RelatedUsersEmails: "malinowski@demo.pl",
    PhoneNumber: "511100100",
  },
  {
    PlayerId: "00000000-0000-0000-0000-000000000202",
    Name: "Filip Jankowski",
    PhotoFilePath: demoPlayerPhoto("00000000-0000-0000-0000-000000000202"),
    Birthday: new Date("2011-08-19"),
    Level: TRANSFER_LEVEL["Członkowska"],
    State: PLAYER_STATE["Aktywny"],
    CurrentState: PLAYER_STATE["Aktywny"] as unknown as IAcademyPlayer["CurrentState"],
    GroupName: "Trampkarz 2014",
    GroupId: DEMO_GROUP_U14W,
    Status: "0",
    Academy: { AcademyId: DEMO_ACADEMY_NORTH_ID, Name: "Oddział Akademii" },
    TotalUnpaidTransactionsAmount: 0,
    HasAppliedPass: true,
    RelatedUsersEmails: "jankowski@demo.pl",
    PhoneNumber: "511100101",
  },
  {
    PlayerId: "00000000-0000-0000-0000-000000000203",
    Name: "Oskar Mazur",
    PhotoFilePath: demoPlayerPhoto("00000000-0000-0000-0000-000000000203"),
    Birthday: new Date("2009-02-03"),
    Level: TRANSFER_LEVEL["Członkowska"],
    State: PLAYER_STATE["Aktywny"],
    CurrentState: PLAYER_STATE["Aktywny"] as unknown as IAcademyPlayer["CurrentState"],
    GroupName: "U16 Liga",
    GroupId: "00000000-0000-0000-0000-000000001702",
    Status: "0",
    Academy: { AcademyId: DEMO_ACADEMY_NORTH_ID, Name: "Oddział Akademii" },
    TotalUnpaidTransactionsAmount: 40,
    HasAppliedPass: true,
    RelatedUsersEmails: "mazur@demo.pl",
    PhoneNumber: "511100102",
  },
  {
    PlayerId: "00000000-0000-0000-0000-000000000301",
    Name: "Nikodem Wójcik",
    PhotoFilePath: demoPlayerPhoto("00000000-0000-0000-0000-000000000301"),
    Birthday: new Date("2012-06-14"),
    Level: TRANSFER_LEVEL["Członkowska"],
    State: PLAYER_STATE["Aktywny"],
    CurrentState: PLAYER_STATE["Aktywny"] as unknown as IAcademyPlayer["CurrentState"],
    GroupName: "Młodzik",
    GroupId: "00000000-0000-0000-0000-000000001703",
    Status: "0",
    Academy: { AcademyId: DEMO_ACADEMY_NORTH_ID, Name: "Oddział Akademii" },
    TotalUnpaidTransactionsAmount: 0,
    HasAppliedPass: false,
    RelatedUsersEmails: "wojcik@demo.pl",
    PhoneNumber: "511100103",
  },
  {
    PlayerId: "00000000-0000-0000-0000-000000000302",
    Name: "Igor Szymański",
    PhotoFilePath: demoPlayerPhoto("00000000-0000-0000-0000-000000000302"),
    Birthday: new Date("2012-09-28"),
    Level: TRANSFER_LEVEL["Członkowska"],
    State: PLAYER_STATE["Aktywny"],
    CurrentState: PLAYER_STATE["Aktywny"] as unknown as IAcademyPlayer["CurrentState"],
    GroupName: "Młodzik",
    GroupId: "00000000-0000-0000-0000-000000001703",
    Status: "0",
    Academy: { AcademyId: DEMO_ACADEMY_NORTH_ID, Name: "Oddział Akademii" },
    TotalUnpaidTransactionsAmount: 20,
    HasAppliedPass: true,
    RelatedUsersEmails: "szymanski@demo.pl",
    PhoneNumber: "511100104",
  },
  {
    PlayerId: "00000000-0000-0000-0000-000000000303",
    Name: "Bartosz Krawczyk",
    PhotoFilePath: demoPlayerPhoto("00000000-0000-0000-0000-000000000303"),
    Birthday: new Date("2010-10-05"),
    Level: TRANSFER_LEVEL["Obserwacja"],
    State: PLAYER_STATE["Zawodnik obserwowany"],
    CurrentState: PLAYER_STATE["Zawodnik obserwowany"] as unknown as IAcademyPlayer["CurrentState"],
    GroupName: "Młodzik 2013",
    GroupId: "00000000-0000-0000-0000-000000001801",
    Status: "0",
    Academy: { AcademyId: DEMO_ACADEMY_SOUTH_ID, Name: "Oddział Akademii - Zachodni" },
    TotalUnpaidTransactionsAmount: 75,
    HasAppliedPass: false,
    RelatedUsersEmails: "krawczyk@demo.pl",
    PhoneNumber: "512200200",
  },
];

const playerFilters = [
  (player: MockAcademyPlayer, pageInfo: any) =>
    matchesAcademyIds(player.Academy?.AcademyId, pageInfo),
  (player: MockAcademyPlayer, pageInfo: any) => matchesOptionalNumber(player.Level, pageInfo.Level),
  (player: MockAcademyPlayer, pageInfo: any) => matchesOptionalNumber(player.State, pageInfo.State),
  (player: MockAcademyPlayer, pageInfo: any) =>
    matchesHasAppliedPass(player.HasAppliedPass, pageInfo.HasAppliedPass),
  (player: MockAcademyPlayer, pageInfo: any) =>
    matchesGroupIds(player.GroupId ? [player.GroupId] : undefined, pageInfo),
];

export const getMockPlayersPage = demoApi((pageInfo: any): IListPageResponse<IAcademyPlayer> =>
  createMockListPage(mockPlayers, pageInfo, {
    search: (player, search) => player.Name.toLowerCase().includes(search),
    filters: playerFilters,
  }));
